{
  "el": {
    "ai": {
      "activation": {
        "activate": "Ενεργοποίηση",
        "activated": "Ο βοηθός AI είναι ενεργός για {client}.",
        "agreement_required": "Τσέκαρε πρώτα το πλαίσιο συμφωνίας.",
        "deactivated": "Ο βοηθός AI είναι ανενεργός για {client}.",
        "not_now": "Όχι τώρα",
        "prompt": {
          "agreement": "Εκ μέρους της {client}, συμφωνώ με τη χρήση του Google Cloud ως υπεργολάβου επεξεργασίας για αυτή τη λειτουργία.",
          "dpa_label": "Ενημερωμένη σύμβαση επεξεργασίας δεδομένων",
          "dpa_url": "https://ziggu.io/terms-and-conditions-13-10-2026",
          "intro": "Σύνοψη συνομιλιών και προτάσεις απαντήσεων. Δωρεάν δοκιμή έως τις 31 Δεκεμβρίου 2026.",
          "processing": "Για τη χρήση του βοηθού, το κείμενο των συνομιλιών επεξεργάζεται μέσω του Google Cloud (Gemini) εντός της ΕΕ. Η Google δεν χρησιμοποιεί αυτά τα δεδομένα για την εκπαίδευση μοντέλων.",
          "retention": "Διατηρούμε τις συνομιλίες με τον βοηθό για {count} μήνα. | Διατηρούμε τις συνομιλίες με τον βοηθό για {count} μήνες.",
          "settings": "Μπορείς να ενεργοποιήσεις ή να απενεργοποιήσεις τον βοηθό ανά πάσα στιγμή στις ρυθμίσεις, στο {features} > {conversations}.",
          "title": "Νέο: βοηθός AI για την ομάδα του έργου σου"
        },
        "settings": {
          "description": "Συνοψίζει συνομιλίες και προτείνει απαντήσεις. Για την ενεργοποίηση χρειάζεται η συμφωνία σου με το Google Cloud ως υπεργολάβο επεξεργασίας.",
          "impersonation": "Μόνο ένας ιδιοκτήτης του πελάτη μπορεί να το ενεργοποιήσει ή να το απενεργοποιήσει, όχι σε συνεδρία «σύνδεση ως».",
          "owner_only": "Ζήτησε από έναν ιδιοκτήτη να ενεργοποιήσει τον βοηθό AI.",
          "owner_only_enabled": "Μόνο ένας ιδιοκτήτης μπορεί να απενεργοποιήσει τον βοηθό AI.",
          "title": "Βοηθός AI",
          "toggle": "Βοηθός AI στις συνομιλίες"
        },
        "snoozed": "Μπορείς να ενεργοποιήσεις τον βοηθό AI αργότερα στις ρυθμίσεις, στο {features} > {conversations}."
      },
      "assistant": {
        "all_projects": "Όλα τα έργα",
        "cap": {
          "action": "Έναρξη νέας συνομιλίας",
          "message": "Έφτασες στο όριο συνομιλιών."
        },
        "empty_state": {
          "subtitle": "Ρώτησέ με οτιδήποτε για τους πελάτες σου",
          "title": "Πώς μπορώ να σε βοηθήσω;"
        },
        "errors": {
          "budget_reached": "Ο προϋπολογισμός AI αυτού του μήνα εξαντλήθηκε. Επικοινώνησε με τη Ziggu για να τον αυξήσεις.",
          "generic": "Κάτι πήγε στραβά. Δοκίμασε ξανά."
        },
        "history": {
          "empty": "Δεν υπάρχουν ακόμα προηγούμενες συνομιλίες",
          "title": "Προηγούμενες συνομιλίες"
        },
        "input": {
          "disclaimer": "Τα αποτελέσματα ενδέχεται να μην είναι ακριβή. Επαλήθευε πάντα τις σημαντικές πληροφορίες.",
          "hint": "Enter για αποστολή · Shift+Enter για νέα γραμμή",
          "placeholder": "Ρώτησε για τους πελάτες σου..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Πώς ρυθμίζω τις ειδοποιήσεις;",
          "help_project_settings": "Πού βρίσκω τις ρυθμίσεις έργου;",
          "open_decisions": "Ποιες αποφάσεις είναι ακόμα ανοιχτές;",
          "unassigned_units": "Ποια ακίνητα δεν έχουν ακόμα πελάτη;"
        },
        "support_cta": {
          "action": "Επικοινωνία με την υποστήριξη",
          "prompt": "Δεν βρήκες την απάντηση που έψαχνες;"
        }
      },
      "dashboard": {
        "agents": {
          "all": "Όλες οι μονάδες",
          "assistant": "Βοηθός",
          "conversation_agent": "Πράκτορας συνομιλίας",
          "label": "Μονάδα"
        },
        "allowance": {
          "edit": "Επεξεργασία προϋπολογισμού"
        },
        "allowance_boost": {
          "action": "Προσωρινή αύξηση",
          "action_short": "Αύξηση",
          "amount_label": "Επιπλέον ποσό",
          "existing": "Αυτή την περίοδο υπάρχει ήδη ενεργή αύξηση {amount}. Το ποσό προστίθεται σε αυτήν.",
          "expires": "Προστίθεται στον προϋπολογισμό μόνο για αυτή την περίοδο και λήγει στις {date}.",
          "expires_next_reset": "Προστίθεται στον προϋπολογισμό μόνο για αυτή την περίοδο και λήγει στην επόμενη επαναφορά.",
          "save": "Προσθήκη αύξησης",
          "saved": "Προστέθηκε αύξηση {amount}"
        },
        "allowance_history": {
          "empty": "Καμία αλλαγή ακόμη",
          "empty_hint": "Αυτός ο πελάτης εξακολουθεί να λειτουργεί με τον προϋπολογισμό που του δόθηκε.",
          "entry": "{field}: {before} → {after}",
          "package_amount": "ποσό πακέτου",
          "title": "Ιστορικό προϋπολογισμού",
          "unknown_author": "Άγνωστο"
        },
        "chat_detail": {
          "employee": "Υπάλληλος",
          "empty": "Αυτή η συνομιλία δεν έχει μηνύματα",
          "feedback": {
            "down": "Κακή απάντηση",
            "up": "Καλή απάντηση"
          },
          "text_hidden": "Δεν κοινοποιήθηκε από τον υπάλληλο",
          "title": "Συνομιλία"
        },
        "chats": {
          "columns": {
            "cost": "Κόστος",
            "employee": "Υπάλληλος",
            "intent": "Πρόθεση",
            "ticket": "Αίτημα",
            "turns": "Γύροι",
            "when": "Πότε"
          },
          "empty": "Καμία συνομιλία σε αυτή την περίοδο",
          "feedback_label": "Αξιολόγηση",
          "feedbacks": {
            "all": "Οποιαδήποτε αξιολόγηση",
            "down": "Αρνητική",
            "up": "Θετική"
          },
          "intent_label": "Πρόθεση",
          "open": "Άνοιγμα συνομιλίας",
          "title": "Συνομιλίες",
          "via": "μέσω {name}"
        },
        "client": {
          "allowance_boost": "{amount} επιπλέον έως τις {date}",
          "allowance_boost_next_reset": "{amount} επιπλέον έως την επόμενη επαναφορά",
          "allowance_free": "{amount} δωρεάν",
          "allowance_paid": "{amount} πληρωμένο",
          "employees_active": "{count} ενεργός υπάλληλος | {count} ενεργοί υπάλληλοι",
          "over_since": "Υπέρβαση από {date}",
          "title": "{name} · AI",
          "used": "{used} από {allowance} σε χρήση"
        },
        "clients": {
          "allowance_split": "Δωρεάν {free} · Πληρωμένο {paid}",
          "allowance_split_boost": "Δωρεάν {free} · Πληρωμένο {paid} · Επιπλέον {boost}",
          "columns": {
            "actions": "Ενέργειες",
            "allowance": "Προϋπολογισμός",
            "chats": "Συνομιλίες στην περίοδο",
            "client": "Πελάτης",
            "spend": "Δαπάνη στην περίοδο",
            "status": "Κατάσταση",
            "used": "Σε χρήση αυτόν τον μήνα"
          },
          "empty": "Κανένας πελάτης δεν χρησιμοποίησε AI σε αυτή την περίοδο",
          "export": "Εξαγωγή",
          "title": "Πελάτες"
        },
        "empty_hint": "Κανένα αποτέλεσμα για αυτή τη μονάδα και περίοδο.",
        "intent_mix": {
          "empty": "Καμία συνομιλία σε αυτή την περίοδο",
          "row": "{chats} συνομιλία · {amount} | {chats} συνομιλίες · {amount}",
          "title": "Κατανομή ανά πρόθεση"
        },
        "intents": {
          "all": "Όλες οι προθέσεις",
          "draft": "Σύνταξη απάντησης",
          "none": "Χωρίς πρόθεση",
          "question": "Ρώτησε",
          "summary": "Σύνοψη"
        },
        "kpi": {
          "clients_active": "Ενεργοί πελάτες",
          "employees_active": "Ενεργοί υπάλληλοι",
          "spend_month": "Δαπάνη αυτόν τον μήνα",
          "spend_month_detail": "Τρέχων ημερολογιακός μήνας",
          "spend_range": "Δαπάνη στην περίοδο",
          "spend_range_detail": "{count} συνομιλία σε αυτή την περίοδο | {count} συνομιλίες σε αυτή την περίοδο",
          "spend_today": "Δαπάνη σήμερα",
          "tickets_assisted": "Υποστηριγμένα αιτήματα"
        },
        "load_failed": {
          "description": "Ανανέωσε τη σελίδα ή επίλεξε άλλη περίοδο.",
          "title": "Δεν ήταν δυνατή η φόρτωση της χρήσης AI"
        },
        "range": {
          "label": "Περίοδος"
        },
        "spend": {
          "empty": "Καμία δαπάνη σε αυτή την περίοδο",
          "monthly_empty": "Καμία δαπάνη τους τελευταίους {months} μήνες",
          "monthly_hint": "Τελευταίοι {months} μήνες · ανεξάρτητο από το επιλεγμένο εύρος",
          "monthly_title": "Κόστος ανά μήνα",
          "monthly_total": "{amount} τους τελευταίους {months} μήνες · ανεξάρτητο από το επιλεγμένο εύρος",
          "title": "Δαπάνη ανά ημέρα",
          "total": "{amount} στην περίοδο",
          "view": {
            "label": "Εμφάνιση δαπάνης",
            "per_day": "Ανά ημέρα",
            "running_total": "Σωρευτικά"
          }
        },
        "status": {
          "over": "Υπέρβαση προϋπολογισμού",
          "over_days": "Υπέρβαση · 1 ημέρα | Υπέρβαση · {count} ημέρες"
        },
        "title": "Χρήση AI"
      },
      "settings": {
        "budget": {
          "amount_error": "Γράψε ένα ποσό όπως 2 ή 2.50",
          "boost_label": "Προσωρινή αύξηση",
          "boost_label_until": "Προσωρινή αύξηση έως τις {date}",
          "description": "Μηνιαίο ανώτατο όριο κόστους για τη χρήση AI (δοκιμαστική φάση). Επανυπολογίζεται με βάση τη χρήση tokens σε όλες τις συνομιλίες αυτόν τον μήνα.",
          "free_label": "Δωρεάν προϋπολογισμός",
          "override_help": "Άφησέ το κενό για να χρησιμοποιηθεί το ποσό του πακέτου ({amount}).",
          "override_label": "Προσαρμοσμένος δωρεάν προϋπολογισμός",
          "paid_label": "Πληρωμένος προϋπολογισμός",
          "save": "Αποθήκευση",
          "title": "Μηνιαίος προϋπολογισμός",
          "total_label": "Συνολικός προϋπολογισμός",
          "usage_label": "Χρήση αυτόν τον μήνα",
          "usage_of": "Χρήση αυτόν τον μήνα, από {amount}",
          "use_package_amount": "Χρήση ποσού πακέτου"
        },
        "description": "Διαμόρφωση για λειτουργίες AI στον οργανισμό σου.",
        "title": "Ρυθμίσεις AI",
        "usage": {
          "description": "Πόσο από το όριο AI αυτού του μήνα έχει χρησιμοποιηθεί. Στο 100% οι λειτουργίες AI σταματούν μέχρι να ανανεωθεί το όριο τον επόμενο μήνα.",
          "title": "Χρήση AI"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Προσαρμογή",
          "ask": "Αποστολή ερώτησης",
          "draft": "Σύνταξη απάντησης",
          "draft_empty": "Δεν υπάρχουν ακόμη μηνύματα για απάντηση",
          "follow_up": "Συμπληρωματική",
          "follow_up_stop": "Διακοπή συμπληρωματικής",
          "new": "Νέα ερώτηση",
          "summary": "Σύνοψη συνομιλίας",
          "summary_empty": "Δεν υπάρχουν ακόμη μηνύματα για σύνοψη",
          "use_as_reply": "Χρήση ως απάντηση"
        },
        "adjusting_draft": "Προσαρμογή αυτού του πρόχειρου",
        "beta": "Beta",
        "beta_tooltip": "Δωρεάν έως το τέλος του 2026. Στη συνέχεια, η χρήση θα είναι περιορισμένη.",
        "budget": {
          "description": "Ο προϋπολογισμός AI αυτού του μήνα εξαντλήθηκε. Οι προηγούμενες απαντήσεις παραμένουν διαθέσιμες.",
          "request": "Εξαντλήσαμε τον προϋπολογισμό AI αυτού του μήνα και θέλουμε να τον αυξήσουμε.",
          "request_low": "Έχουμε σχεδόν εξαντλήσει τον προϋπολογισμό AI αυτού του μήνα και θέλουμε να τον αυξήσουμε.",
          "title": "Ο προϋπολογισμός AI εξαντλήθηκε",
          "warn": "Χρησιμοποιήθηκε το {percent}% του προϋπολογισμού AI αυτού του μήνα."
        },
        "cap": "Αυτή η συνομιλία έχει μεγαλώσει. Κάνε καλύτερα μια νέα ερώτηση.",
        "collapse": "Απόκρυψη βοηθού",
        "conversation": "Συνομιλία",
        "digest": {
          "decisions_open": "καμία ανοιχτή απόφαση | 1 ανοιχτή απόφαση | {count} ανοιχτές αποφάσεις",
          "installments_unpaid": "καμία απλήρωτη δόση | 1 απλήρωτη δόση | {count} απλήρωτες δόσεις",
          "issues_open": "καμία ανοιχτή παρατήρηση | 1 ανοιχτή παρατήρηση | {count} ανοιχτές παρατηρήσεις",
          "nothing_open": "Τίποτα σε εκκρεμότητα για αυτό το ακίνητο",
          "overdue": "{count} εκπρόθεσμες | {count} εκπρόθεσμη | {count} εκπρόθεσμες",
          "title": "Με μια ματιά"
        },
        "earlier_answers": "Προηγούμενες απαντήσεις",
        "empty": "Ρώτησε κάτι για αυτή τη συνομιλία ή ξεκίνα με μία από αυτές.",
        "expand": "Εμφάνιση βοηθού",
        "feedback": {
          "bad": "Κακή απάντηση",
          "consent": "Η Ziggu θα δει αυτή τη συνομιλία. Μπορεί να περιέχει ονόματα και στοιχεία πελατών.",
          "consent_shared": "Αυτή η συνομιλία έχει ήδη κοινοποιηθεί στη Ziggu.",
          "good": "Καλή απάντηση",
          "note": "Τι θα έπρεπε να είχε πει; (προαιρετικό)",
          "send": "Αποστολή",
          "share": "Κοινοποίηση στη Ziggu",
          "stop_sharing": "Διακοπή κοινοποίησης",
          "thanks": "Ευχαριστούμε για τα σχόλιά σου.",
          "thanks_shared": "Ευχαριστούμε. Κοινοποιήθηκε στη Ziggu.",
          "undo": "Αναίρεση"
        },
        "following_up": "Συμπληρωματική σε αυτή την απάντηση",
        "footer": "Η υποστήριξη της Ziggu το διαβάζει μόνο αν το κοινοποιήσεις ή δώσεις πρόσβαση στη Ziggu. Οι απαντήσεις δημιουργούνται από AI και μπορεί να περιέχουν λάθη.",
        "footer_shared": "Κοινοποίησες αυτή τη συνομιλία στη Ziggu. Οι απαντήσεις δημιουργούνται από AI και μπορεί να περιέχουν λάθη.",
        "input": {
          "adjust_draft": "Προσάρμοσε αυτό το πρόχειρο, π.χ. πιο σύντομο ή πιο επίσημο",
          "follow_up": "Κάνε μια συμπληρωματική ερώτηση",
          "label": "Η ερώτησή σου",
          "placeholder": "Ρώτησε για αυτή τη συνομιλία"
        },
        "links": {
          "aftercare": "Παρατηρήσεις",
          "decisions": "Αποφάσεις",
          "financials": "Οικονομικά"
        },
        "placeholders": {
          "confirm": {
            "accept": "Αποστολή ούτως ή άλλως",
            "header": "Αποστολή με κενά πεδία;",
            "message": "Ο βοηθός άφησε 1 πεδίο χωρίς συμπλήρωση σε αυτή την απάντηση. | Ο βοηθός άφησε {count} πεδία χωρίς συμπλήρωση σε αυτή την απάντηση."
          },
          "remaining": "1 πεδίο προς συμπλήρωση | {count} πεδία προς συμπλήρωση"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Αντικατάσταση",
            "header": "Αντικατάσταση του κειμένου σου;",
            "message": "Το πρόχειρο αντικαθιστά το κείμενο στο πεδίο απάντησης."
          }
        },
        "resize": "Αλλαγή πλάτους βοηθού",
        "suggestions": {
          "history": "Ποιο είναι το ιστορικό με αυτόν τον πελάτη;",
          "issues_open": "Πόσες παρατηρήσεις παραμένουν ανοιχτές;",
          "undecided": "Τι δεν έχει αποφασίσει ακόμη αυτός ο πελάτης;"
        },
        "thinking": "Ο βοηθός εργάζεται...",
        "title": "Βοηθός"
      }
    }
  }
}
